import moment from "moment";
import { Link } from "react-router-dom";

const LastBox = ({userlang}) => {
    return (
        <div className="lastBox">
            <p>© {moment().format('Y')}  All rights reserved.</p>
            <ul>
                <li><Link  to={'/' + userlang + '/terms-and-conditions'}>Term & Condition</Link></li>
                <li><Link h to={'/' + userlang + '/contact-us'}>Contact us</Link></li>
            </ul>
        </div>
    )
}
export default LastBox;
